import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { dynamicElementsTabs } from '@epicuro-next/constants/dynamic-elements';
import { DynamicElementsTooltipDirective } from '@epicuro-next/dynamic-elements/dynamic-tooltip';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { DynamicLogicalOperationsModule } from '@epicuro-next/platform/dynamic-logical-operations';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, filter, startWith, Subject, takeUntil } from 'rxjs';

interface ITabItem {
  label: {
    routerLink?: unknown[];
    children: IDynamicItem[];
  };
  content?: IDynamicItem;
}

@DynamicComponentRegister(dynamicElementsTabs)
@Component({
  selector: 'epc-dynamic-elements-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  imports: [
    CommonModule,
    NgbNavModule,
    DynamicComponentsModule,
    RouterModule,
    DynamicLogicalOperationsModule,
    DynamicElementsTooltipDirective,
  ],
})
export class DynamicElementsTabsComponent implements OnInit, OnDestroy {
  public active$ = new BehaviorSubject(0);

  private destroy$ = new Subject<void>();

  @Input()
  public items: ITabItem[] = [];

  constructor(private router: Router) {}

  public ngOnInit() {
    if (this.items.some((item) => !item.label.routerLink)) {
      this.active$.next(0);

      return;
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(true),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        const index = this.items.findIndex((item) => {
          return (
            this.router.url.indexOf((item.label.routerLink ?? []).join('/')) >
            -1
          );
        });

        this.active$.next(index < 0 ? 0 : index);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onActiveChange(data: number) {
    this.active$.next(data);
  }
}

DontTreeShake(DynamicElementsTabsComponent);
